import { render, staticRenderFns } from "./SubCommunityGovernance.vue?vue&type=template&id=4a1a58aa&scoped=true&"
import script from "./SubCommunityGovernance.vue?vue&type=script&lang=js&"
export * from "./SubCommunityGovernance.vue?vue&type=script&lang=js&"
import style0 from "./SubCommunityGovernance.vue?vue&type=style&index=0&id=4a1a58aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a58aa",
  null
  
)

export default component.exports